import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import serviceDashboardService, {
  OperationalDashboardFilters,
  OperationalDashboardResponse,
} from "@/services/service-dashboard.service";

const REFRESH_INTERVAL_MS = 10 * 60 * 1000;

export type UseGetOperationalDashboardProps = OperationalDashboardFilters & {
  autoRefresh?: boolean;
};

export type UseGetOperationalDashboardReturn = {
  data: OperationalDashboardResponse | null;
  isLoading: boolean;
  isRefreshing: boolean;
  error: Error | null;
  refresh: () => void;
};

const useGetOperationalDashboard = ({
  queueIds,
  workflowIds,
  tagNames,
  autoRefresh = false,
}: UseGetOperationalDashboardProps): UseGetOperationalDashboardReturn => {
  const { data = null, isLoading, isValidating, error, mutate } = useSWR(
    [SWR_KEYS.getOperationalDashboard, queueIds, workflowIds, tagNames],
    () => serviceDashboardService.operational({ queueIds, workflowIds, tagNames }),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      errorRetryCount: 0,
      refreshInterval: autoRefresh ? REFRESH_INTERVAL_MS : 0,
    }
  );

  return {
    data,
    isLoading,
    isRefreshing: Boolean(data) && isValidating,
    error,
    refresh: () => {
      void mutate();
    },
  };
};

export default useGetOperationalDashboard;
